'use strict';

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var CID = require('cids');

var _require = require('../../../utils/cid'),
    cidToString = _require.cidToString;

var log = require('debug')('ipfs:repo:gc');

var _require2 = require('../../utils'),
    MFS_ROOT_KEY = _require2.MFS_ROOT_KEY;

var Repo = require('ipfs-repo');

var _require3 = require('interface-datastore'),
    Errors = _require3.Errors;

var ERR_NOT_FOUND = Errors.notFoundError().code;

var _require4 = require('streaming-iterables'),
    parallelMerge = _require4.parallelMerge,
    transform = _require4.transform,
    map = _require4.map; // Limit on the number of parallel block remove operations


var BLOCK_RM_CONCURRENCY = 256; // Perform mark and sweep garbage collection

module.exports = function (_ref3) {
  var gcLock = _ref3.gcLock,
      pin = _ref3.pin,
      pinManager = _ref3.pinManager,
      refs = _ref3.refs,
      repo = _ref3.repo;
  return /*#__PURE__*/function () {
    var _gc = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var start, release, markedSet, blockKeys;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              start = Date.now();
              log('Creating set of marked blocks');
              _context.next = 4;
              return _awaitAsyncGenerator(gcLock.writeLock());

            case 4:
              release = _context.sent;
              _context.prev = 5;
              _context.next = 8;
              return _awaitAsyncGenerator(createMarkedSet({
                pin: pin,
                pinManager: pinManager,
                refs: refs,
                repo: repo
              }));

            case 8:
              markedSet = _context.sent;
              // Get all blocks keys from the blockstore
              blockKeys = repo.blocks.query({
                keysOnly: true
              }); // Delete blocks that are not being used

              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(deleteUnmarkedBlocks({
                repo: repo,
                refs: refs
              }, markedSet, blockKeys)), _awaitAsyncGenerator), "t0", 11);

            case 11:
              log("Complete (".concat(Date.now() - start, "ms)"));

            case 12:
              _context.prev = 12;
              release();
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5,, 12, 15]]);
    }));

    function gc() {
      return _gc.apply(this, arguments);
    }

    return gc;
  }();
}; // Get Set of CIDs of blocks to keep


function createMarkedSet(_x4) {
  return _createMarkedSet.apply(this, arguments);
} // Delete all blocks that are not marked as in use


function _createMarkedSet() {
  _createMarkedSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref4) {
    var pin, pinManager, refs, repo, pinsSource, pinInternalsSource, mfsSource, output, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, cid;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            pin = _ref4.pin, pinManager = _ref4.pinManager, refs = _ref4.refs, repo = _ref4.repo;
            pinsSource = map(function (_ref8) {
              var cid = _ref8.cid;
              return cid;
            }, pin.ls());
            pinInternalsSource = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              var cids;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      _context4.next = 2;
                      return _awaitAsyncGenerator(pinManager.getInternalBlocks());

                    case 2:
                      cids = _context4.sent;
                      return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(cids), _awaitAsyncGenerator), "t0", 4);

                    case 4:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            }))();
            mfsSource = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              var mh, rootCid, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, _value4, ref;

              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.prev = 0;
                      _context5.next = 3;
                      return _awaitAsyncGenerator(repo.root.get(MFS_ROOT_KEY));

                    case 3:
                      mh = _context5.sent;
                      _context5.next = 12;
                      break;

                    case 6:
                      _context5.prev = 6;
                      _context5.t0 = _context5["catch"](0);

                      if (!(_context5.t0.code === ERR_NOT_FOUND)) {
                        _context5.next = 11;
                        break;
                      }

                      log('No blocks in MFS');
                      return _context5.abrupt("return");

                    case 11:
                      throw _context5.t0;

                    case 12:
                      rootCid = new CID(mh);
                      _context5.next = 15;
                      return rootCid;

                    case 15:
                      _iteratorNormalCompletion2 = true;
                      _didIteratorError2 = false;
                      _context5.prev = 17;
                      _iterator2 = _asyncIterator(refs(rootCid, {
                        recursive: true
                      }));

                    case 19:
                      _context5.next = 21;
                      return _awaitAsyncGenerator(_iterator2.next());

                    case 21:
                      _step2 = _context5.sent;
                      _iteratorNormalCompletion2 = _step2.done;
                      _context5.next = 25;
                      return _awaitAsyncGenerator(_step2.value);

                    case 25:
                      _value2 = _context5.sent;

                      if (_iteratorNormalCompletion2) {
                        _context5.next = 33;
                        break;
                      }

                      _value4 = _value2, ref = _value4.ref;
                      _context5.next = 30;
                      return new CID(ref);

                    case 30:
                      _iteratorNormalCompletion2 = true;
                      _context5.next = 19;
                      break;

                    case 33:
                      _context5.next = 39;
                      break;

                    case 35:
                      _context5.prev = 35;
                      _context5.t1 = _context5["catch"](17);
                      _didIteratorError2 = true;
                      _iteratorError2 = _context5.t1;

                    case 39:
                      _context5.prev = 39;
                      _context5.prev = 40;

                      if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                        _context5.next = 44;
                        break;
                      }

                      _context5.next = 44;
                      return _awaitAsyncGenerator(_iterator2.return());

                    case 44:
                      _context5.prev = 44;

                      if (!_didIteratorError2) {
                        _context5.next = 47;
                        break;
                      }

                      throw _iteratorError2;

                    case 47:
                      return _context5.finish(44);

                    case 48:
                      return _context5.finish(39);

                    case 49:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, null, [[0, 6], [17, 35, 39, 49], [40,, 44, 48]]);
            }))();
            output = new Set();
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context6.prev = 7;
            _iterator = _asyncIterator(parallelMerge(pinsSource, pinInternalsSource, mfsSource));

          case 9:
            _context6.next = 11;
            return _iterator.next();

          case 11:
            _step = _context6.sent;
            _iteratorNormalCompletion = _step.done;
            _context6.next = 15;
            return _step.value;

          case 15:
            _value = _context6.sent;

            if (_iteratorNormalCompletion) {
              _context6.next = 22;
              break;
            }

            cid = _value;
            output.add(cidToString(cid, {
              base: 'base32'
            }));

          case 19:
            _iteratorNormalCompletion = true;
            _context6.next = 9;
            break;

          case 22:
            _context6.next = 28;
            break;

          case 24:
            _context6.prev = 24;
            _context6.t0 = _context6["catch"](7);
            _didIteratorError = true;
            _iteratorError = _context6.t0;

          case 28:
            _context6.prev = 28;
            _context6.prev = 29;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context6.next = 33;
              break;
            }

            _context6.next = 33;
            return _iterator.return();

          case 33:
            _context6.prev = 33;

            if (!_didIteratorError) {
              _context6.next = 36;
              break;
            }

            throw _iteratorError;

          case 36:
            return _context6.finish(33);

          case 37:
            return _context6.finish(28);

          case 38:
            return _context6.abrupt("return", output);

          case 39:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[7, 24, 28, 38], [29,, 33, 37]]);
  }));
  return _createMarkedSet.apply(this, arguments);
}

function deleteUnmarkedBlocks(_x, _x2, _x3) {
  return _deleteUnmarkedBlocks.apply(this, arguments);
}

function _deleteUnmarkedBlocks() {
  _deleteUnmarkedBlocks = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5, markedSet, blockKeys) {
    var repo, refs, blocksCount, removedBlocksCount, removeBlock, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, res;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            repo = _ref5.repo, refs = _ref5.refs;
            // Iterate through all blocks and find those that are not in the marked set
            // blockKeys yields { key: Key() }
            blocksCount = 0;
            removedBlocksCount = 0;

            removeBlock = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref6) {
                var k, cid, b32, res, msg;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        k = _ref6.key;
                        blocksCount++;
                        _context2.prev = 2;
                        cid = Repo.utils.blockstore.keyToCid(k);
                        b32 = cid.toV1().toString('base32');

                        if (!markedSet.has(b32)) {
                          _context2.next = 7;
                          break;
                        }

                        return _context2.abrupt("return", null);

                      case 7:
                        res = {
                          cid: cid
                        };
                        _context2.prev = 8;
                        _context2.next = 11;
                        return repo.blocks.delete(cid);

                      case 11:
                        removedBlocksCount++;
                        _context2.next = 17;
                        break;

                      case 14:
                        _context2.prev = 14;
                        _context2.t0 = _context2["catch"](8);
                        res.err = new Error("Could not delete block with CID ".concat(cid, ": ").concat(_context2.t0.message));

                      case 17:
                        return _context2.abrupt("return", res);

                      case 20:
                        _context2.prev = 20;
                        _context2.t1 = _context2["catch"](2);
                        msg = "Could not convert block with key '".concat(k, "' to CID");
                        log(msg, _context2.t1);
                        return _context2.abrupt("return", {
                          err: new Error(msg + ": ".concat(_context2.t1.message))
                        });

                      case 25:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[2, 20], [8, 14]]);
              }));

              return function removeBlock(_x5) {
                return _ref7.apply(this, arguments);
              };
            }();

            _iteratorNormalCompletion3 = true;
            _didIteratorError3 = false;
            _context3.prev = 6;
            _iterator3 = _asyncIterator(transform(BLOCK_RM_CONCURRENCY, removeBlock, blockKeys));

          case 8:
            _context3.next = 10;
            return _awaitAsyncGenerator(_iterator3.next());

          case 10:
            _step3 = _context3.sent;
            _iteratorNormalCompletion3 = _step3.done;
            _context3.next = 14;
            return _awaitAsyncGenerator(_step3.value);

          case 14:
            _value3 = _context3.sent;

            if (_iteratorNormalCompletion3) {
              _context3.next = 23;
              break;
            }

            res = _value3;

            if (!res) {
              _context3.next = 20;
              break;
            }

            _context3.next = 20;
            return res;

          case 20:
            _iteratorNormalCompletion3 = true;
            _context3.next = 8;
            break;

          case 23:
            _context3.next = 29;
            break;

          case 25:
            _context3.prev = 25;
            _context3.t0 = _context3["catch"](6);
            _didIteratorError3 = true;
            _iteratorError3 = _context3.t0;

          case 29:
            _context3.prev = 29;
            _context3.prev = 30;

            if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
              _context3.next = 34;
              break;
            }

            _context3.next = 34;
            return _awaitAsyncGenerator(_iterator3.return());

          case 34:
            _context3.prev = 34;

            if (!_didIteratorError3) {
              _context3.next = 37;
              break;
            }

            throw _iteratorError3;

          case 37:
            return _context3.finish(34);

          case 38:
            return _context3.finish(29);

          case 39:
            log("Marked set has ".concat(markedSet.size, " unique blocks. Blockstore has ").concat(blocksCount, " blocks. ") + "Deleted ".concat(removedBlocksCount, " blocks."));

          case 40:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[6, 25, 29, 39], [30,, 34, 38]]);
  }));
  return _deleteUnmarkedBlocks.apply(this, arguments);
}